import React from 'react';
import styles from '../../../assets/css/styling.module.css';
import styles3 from '../../../assets/css/newStyling.module.css';
import { TransitionGroup } from 'react-transition-group';
import ResizeDetector from "react-resize-detector";
import LoadingOverlay from 'react-loading-overlay-ts';
import Loader from "react-loaders";
import { useState, useEffect } from 'react';
import referImage from '../../../assets/images/refer_image.png'
import bronze_badge from '../../../assets/images/bronze.png'
import silver_badge from '../../../assets/images/silver.png'
import gold_badge from '../../../assets/images/gold.png'
import pointsBadge from '../../../assets/images/medal.png'
import tick_icon from '../../../assets/images/correct.png'
import streak from '../../../assets/images/streak.png'
import { Line, Circle } from 'rc-progress';
import SecureLS from 'secure-ls';
import { useDispatch } from 'react-redux';
import Swal from 'sweetalert'
import { getUserDetails } from '../../../actions/user_action';
import { respondentDashboardDetails } from '../../../actions/dashboard_activities';
import check_mark from '../../../assets/images/check-mark.png'
import coin from '../../../assets/images/coin.png'


function ConnectPoints() {
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    const [profileCompletion, setProfileCompletion] = useState(0)
    const [points, setPoints] = useState(0)
    const [percentToNextThreshold, set_percentToNextThreshold] = useState({})
    const [referCode, setReferCode] = useState('')
    const [copied, setCopied] = useState(false);
    const ls = new SecureLS()
    const userId = ls.get('accessUser').user._id

    useEffect(() => {


        // getting user and dashboard details
        dispatch(getUserDetails(userId))
            .then(response => {

                setReferCode(response.payload.content.referralCode)

                dispatch(respondentDashboardDetails())
                    .then(response2 => {

                        setProfileCompletion(response2.payload.content.profileCompletion)
                        //setProfileCompletion(100)
                        setPoints(response2.payload.content.totalPointsEarned)
                        //setUserPoints(response2.payload.content)

                        //setLoading(false)
                    })
                    .catch(err => {
                        //setLoading(false)
                        Swal({
                            title: err.response ? err.response.data.name : "Error",
                            text: err.response ? err.response.data.content : "Something went wrong",
                            icon: 'error'
                        })
                    })

                //setUserDetails(response.payload.content)
                // getProjectListing(1, 3)
                //getSurvey(1, true)
                // setLoading(false)
            })
            .catch(err => {
                //setLoading(false)
                Swal({
                    title: err.response ? err.response.data.name : "Error",
                    text: err.response ? err.response.data.content : "Something went wrong",
                    icon: 'error'
                })
            })
    }, []);

    const handleLinkClick = () => {

        let link = `https://app.consumerconnect.net/choose?code=${referCode}`
        const textArea = document.createElement('textarea');
        textArea.value = link;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);

        setCopied(true)

        Swal({
            title: 'Link Copied',
            icon: 'success'
        })


    }

    const toReachNextThreshold = () => {
        const currentPoints = points;
        const thresholds = [250, 500, 1000, 2500, 5000];

        let nextThreshold = null;

        for (let i = 0; i < thresholds.length; i++) {
            if (currentPoints < thresholds[i]) {
                nextThreshold = thresholds[i];
                break;
            }
        }


        if (!nextThreshold) {
            set_percentToNextThreshold({
                percentage: 100,
                next: thresholds[thresholds.length - 1]
            });
            return;
        }

        const percentage = (currentPoints / nextThreshold) * 100;

        set_percentToNextThreshold({
            percentage: Math.round(percentage, 100), // safety cap
            next: nextThreshold,
            remaining: nextThreshold - currentPoints
        });
    };
    useEffect(() => {
        toReachNextThreshold()
    }, [points])

    return (
        <TransitionGroup >

            <ResizeDetector
                handleWidth
                render={({ width }) => (

                    <LoadingOverlay tag="div" active={isLoading}
                        styles={{
                            overlay: (base) => ({
                                ...base,
                                background: "#fff",
                                opacity: 0.5,
                                position: 'fixed',
                                top: '20%'
                            }),
                        }}
                        spinner={
                            <Loader color="#6c757d" active type="ball-pulse" />
                        }>

                        <React.Fragment>










                            <div className="row" style={{ marginTop: window.innerWidth > 768 ? '15px' : '25px' }}>

                                <div className='col-12'>
                                    {/* connect points block */}
                                    {/* <div className={styles.card_border}>



                                        <div className={styles.card_border_body + " pt-2 pb-3 px-0"}>
                                            <div style={{ height: '7rem' }}>
                                                <div className='d-flex' style={{ display: 'flex', alignItems: 'flex-end', alignContent: 'flex-end', marginRight: '20px' }}>
                                                    <p className={`${styles3.points} container pt-2`} style={{ margin: '0px' }}>{points}</p>
                                                    <p className={`${styles3.connect_rewards} pb-3`} style={{ minWidth: '60%', margin: '0px' }}>Connect Points</p>

                                                    <img src={pointsBadge} alt='image' className={`${styles3.badge}`}></img>


                                                </div>


                                                <div className='d-flex' >
                                                    <span> <Line className='container' percent={profileCompletion} strokeWidth={4} trailWidth={4} trailColor='#E5E5E5' strokeColor="#47B221" /></span>
                                                    <span style={{
                                                        color: '#ADA7A7',
                                                        fontSize: '15px', fontStyle: 'normal', fontWeight: '500'
                                                    }}>{profileCompletion ? profileCompletion : '0'}% profile</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                   
                                    <div className='pt-4'>
                                        <div className={styles.card_border}>



                                            <div className={styles.card_border_body + " px-3 px-0"}>
                                                <div style={{ height: '10rem' }}>

                                                    <div className='d-flex align-items-center' style={{ height: '100%' }}>

                                                        
                                                        <div style={{ height: '100%', aspectRatio: '1 / 1', position: 'relative' }}>

                                                            <Circle
                                                                percent={percentToNextThreshold.percentage}
                                                                strokeWidth={8}
                                                                trailWidth={8}
                                                                trailColor='#E5E5E5'
                                                                strokeColor="#47B221"
                                                            />

                                                           
                                                            <div
                                                                style={{
                                                                    position: 'absolute',
                                                                    top: '50%',
                                                                    left: '50%',
                                                                    transform: 'translate(-50%, -50%)',
                                                                    textAlign: 'center',
                                                                    lineHeight: '1.1'
                                                                }}
                                                            >
                                                              
                                                                <div
                                                                    style={{
                                                                        fontSize: '35px',
                                                                        fontWeight: '600',
                                                                        color: '#000'
                                                                    }}
                                                                >
                                                                    {percentToNextThreshold?.percentage || '0'}%
                                                                </div>

                                                               
                                                                <div
                                                                    style={{
                                                                        fontSize: '14px',
                                                                        fontWeight: '420',
                                                                        color: '#888',
                                                                        marginTop: '2px'
                                                                    }}
                                                                >
                                                                    completed to reach
                                                                </div>

                                                                
                                                                <div
                                                                    style={{
                                                                        fontSize: '18px',
                                                                        fontWeight: '600',
                                                                        color: '#444'
                                                                    }}
                                                                >
                                                                    {percentToNextThreshold?.next}
                                                                </div>
                                                            </div>

                                                        </div>

                                                        {percentToNextThreshold?.remaining > 0 && <span className={window.innerWidth < 768 ? 'pl-4' : 'pl-4'} style={{
                                                            color: '#ADA7A7',
                                                            fontSize: '15px', fontStyle: 'normal', fontWeight: '500'
                                                        }}>Earn {percentToNextThreshold?.remaining || '0'} more points to reach next target of {percentToNextThreshold?.next || '0'} points</span>}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}

                                    <div
                                        style={{
                                            background: "linear-gradient(180deg, #2895D9 0%, #1A7CC8 100%)",
                                            borderRadius: "24px",
                                            padding: "20px",
                                            color: "#fff",
                                            position: "relative",
                                            overflow: "hidden",
                                        }}
                                    >
                                        {/* Top Section */}
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "15px",
                                                marginBottom: "25px",
                                            }}
                                        >
                                            <img
                                                src={coin}
                                                alt="badge"
                                                style={{
                                                    width: "70px",
                                                    height: "70px",
                                                }}
                                            />

                                            <div>


                                                <div
                                                    style={{
                                                        fontSize: "16px",
                                                        opacity: 1.2,

                                                    }}
                                                >
                                                    Connect Points
                                                </div>
                                                <div className='d-flex align-items-center'>
                                                    <div
                                                        style={{
                                                            fontSize: "30px",
                                                            fontWeight: 500,
                                                            lineHeight: 1.3,

                                                        }}
                                                    >
                                                        {points}
                                                    </div>

                                                    <div
                                                        style={{
                                                            fontSize: "15px",
                                                            fontWeight: 400,
                                                            opacity: 0.7,
                                                            marginLeft: "8px",
                                                            marginTop: "8px",
                                                            fontFamily: "sans-serif",

                                                            lineHeight: 1.3,


                                                        }}

                                                    >
                                                        total earned
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Milestone Box */}
                                        <div
                                            style={{
                                                background: "rgba(0,0,0,0.12)",
                                                border: "1px dashed rgba(255,255,255,0.25)",
                                                borderRadius: "16px",
                                                padding: "18px",
                                            }}
                                        >
                                            {/* Header */}
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    marginBottom: "12px",
                                                    fontSize: "16px",
                                                }}
                                            >
                                                <span>

                                                    Next milestone: {percentToNextThreshold?.next || 250} pts

                                                </span>


                                                <span>
                                                    {percentToNextThreshold?.percentage || 0}%
                                                </span>
                                            </div>

                                            {/* Progress */}
                                            <div
                                                style={{
                                                    width: "100%",
                                                    height: "18px",
                                                    background: "#9BCBF0",
                                                    borderRadius: "20px",
                                                    overflow: "hidden",
                                                    marginBottom: "12px",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        width: `${percentToNextThreshold?.percentage || 0}%`,
                                                        height: "100%",
                                                        background: "#fff",
                                                        borderRadius: "20px",
                                                    }}
                                                />
                                            </div>

                                            {/* Points Row */}
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    marginBottom: "20px",
                                                    fontWeight: 350,
                                                    fontSize: '16px'
                                                }}
                                            >
                                                <span>
                                                    {points} / {percentToNextThreshold?.next || 250} points
                                                </span>

                                                <span>
                                                    <div style={{ fontSize: "16px", fontWeight: 400 }}>
                                                        {percentToNextThreshold?.remaining || 0} pts to go
                                                    </div>
                                                </span>
                                            </div>
                                            {profileCompletion < 100 && <>
                                                <hr
                                                    style={{
                                                        borderColor: "rgba(255,255,255,0.15)",
                                                        borderStyle: "dashed",
                                                    }}
                                                />



                                                <div
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        marginBottom: "12px",
                                                        fontSize: "16px",
                                                    }}
                                                >
                                                    <span>

                                                        Profile Completed

                                                    </span>


                                                    <span>
                                                        {profileCompletion || 0}%
                                                    </span>
                                                </div>
                                            </>
                                            }
                                        </div>
                                    </div>

                                    {/* bronze demo */}
                                    {profileCompletion >= 100 && <div className="pt-3">
                                        {/* <div className={styles.card_border}>

                                            <div className={`${styles.card_border_body} pt-3 pb-0 px-3`}>

                                               
                                                <div className='row'>
                                                    <div className="d-flex mb-2 col-12">
                                                        <img
                                                            src={bronze_badge}
                                                            alt="Bronze Badge"
                                                            className={styles3.rank_badges}
                                                        />
                                                       
                                                        <div className={styles3.rank_requirement}>
                                                            <img src={check_mark} className={`${styles3.tick_icon}`}></img> 100% profile completion
                                                           
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className={styles3.rank_title}>
                                                    Rank <span className={styles3.rank_name}>Bronze</span>
                                                </div>



                                            </div>

                                           
                                            <div className={`${styles3.rank_footer} text-center`}>
                                                No Incentives
                                            </div>

                                        </div> */}
                                        <div style={{ padding: '2px', borderRadius: '16px', background: 'linear-gradient(135deg, #f5a623, #f7c97e, #f5a623)' }}>
                                            <div style={{ background: '#fff', borderRadius: '14px', padding: '19px 20px 19px 16px' }}>

                                                {/* Top: Badge + Rank */}
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>

                                                    {/* Medal Icon */}
                                                    {/* Medal Image */}
                                                    <img
                                                        src={bronze_badge}
                                                        alt="Bronze Badge"
                                                        style={{ width: '50px', height: '56px', objectFit: 'contain', flexShrink: 0 }}
                                                    />

                                                    {/* Rank Text */}
                                                    <div>
                                                        <div style={{ fontSize: '15px', color: '#1a1a1a', marginBottom: '2px' }}>Your current rank</div>
                                                        <div style={{ fontSize: '21px', fontWeight: '500', color: '#1a1a1a' }}>Bronze Member</div>
                                                    </div>
                                                </div>

                                                {/* Dashed Divider */}
                                                <div style={{ borderTop: '1.5px dashed #888', marginBottom: '12px' }} />

                                                {/* Profile Completion */}
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                                    <div style={{ width: '20px', height: '20px', borderRadius: '50%', background: '#228636', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                                        <svg width="13" height="13" viewBox="0 0 12 12" fill="none">
                                                            <polyline points="2,6 5,9 10,3" stroke="#fff" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round" />
                                                        </svg>
                                                    </div>
                                                    <span style={{ fontSize: '15px', color: '#1a1a1a' }}>100% profile completion</span>
                                                </div>

                                            </div>
                                        </div>
                                    </div>}

                                    {/* silver demo */}
                                    {/* <div className="pt-4">
                                        <div className={styles.card_border}>

                                            <div className={`${styles.card_border_body} pt-3 pb-0 px-3`}>

                                               
                                                <div className='row'>
                                                <div className="d-flex mb-2 col-12">
                                                    <img
                                                        src={silver_badge}
                                                        alt="Silver Badge"
                                                        className={styles3.rank_badges}
                                                    />
                                                    
                                                <div className={styles3.rank_requirement}>
                                                   <img src={check_mark} className={`${styles3.tick_icon}`}></img> 3/3 quality check streak for 3 months
                                                    <div className='col-12 text-center pt-3'>
                                                    <img src={streak} className={`${styles3.streak_icon}`}></img>
                                                </div>
                                                </div>
                                                
                                                </div>
                                               
                                                </div>

                                                <div className={styles3.rank_title}>
                                                    Rank <span className={styles3.rank_name_silver}>Silver</span>
                                                </div>

                                                

                                            </div>

                                            
                                            <div className={`${styles3.rank_footer} text-center`}>
                                               <img src={tick_icon} alt='image' className={`${styles3.tick_icon}`}></img> Early access to surveys
                                            </div>

                                        </div>
                                    </div>  */}

                                    {/*gold demo */}
                                    {/* <div className="pt-4">
                                        <div className={styles.card_border}>

                                            <div className={`${styles.card_border_body} pt-3 pb-0 px-3`}>

                                                
                                                <div className='row'>
                                                <div className="d-flex mb-2 col-12">
                                                    <img
                                                        src={gold_badge}
                                                        alt="Gold Badge"
                                                        className={styles3.rank_badges}
                                                    />
                                                    
                                                <div className={styles3.rank_requirement}>
                                                   <img src={check_mark} className={`${styles3.tick_icon}`}></img> 3/3 quality check streak for 6 months
                                                   <div className='col-12 text-center pt-3'>
                                                    <img src={streak} className={`${styles3.streak_icon}`}></img>
                                                </div>
                                                </div>
                                                </div>
                                                </div>

                                                <div className={styles3.rank_title}>
                                                    Rank <span className={styles3.rank_name_gold}>Gold</span>
                                                </div>

                                                

                                            </div>

                                            
                                            <div className={`${styles3.rank_footer} text-center`}>
                                               <img src={tick_icon} alt='image' className={`${styles3.tick_icon}`}></img> Early access & priority payouts
                                            </div>

                                        </div>
                                    </div> */}


                                    {/* refer banner */}
                                    {/* <div className='pt-3'>
                                        <div className={styles3.card_border_borderless} style={{ backgroundColor: '#E6D2FF' }}>




                                            <div className={styles.card_border_body + " pt-2 pb-3 px-0"} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }} onClick={handleLinkClick} >
                                                <div style={{ height: '6rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <p className={`${styles3.refer_block_text} container`} style={{ flex: '50%' }}>Earn points by referring people around.</p>
                                                    <img src={referImage} alt='image' style={{ flex: '50%', maxHeight: '100%', maxWidth: '25%' }}></img>
                                                </div>


                                            </div>
                                        </div>

                                    </div> */}
                                    <div className='pt-3'>
                                        <div
                                            className={styles3.card_border_borderless}
                                            style={{ backgroundColor: '#E6D2FF', borderRadius: '16px', padding: '16px 18px', position: 'relative', overflow: 'hidden' }}
                                        >

                                            <div className={styles.card_border_body + " pt-2 pb-3 px-0"} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                                                <div style={{ height: '6rem', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>

                                                    
                                                    <div style={{ flex: '50%', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                                        <div style={{ fontSize: '15px', fontWeight: '500', color: '#7c3aed' }}>Info Tip:</div>
                                                        <p style={{ margin: 0, fontWeight: '500', fontSize: '17px', color: '#1a1a1a' }}>
                                                            Earn points by referring people around.
                                                        </p>

                                                        {/* URL + Copy Button */}
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                            <div style={{ background: '#fff', borderRadius: '10px', padding: '6px 10px', fontSize: '11px', color: '#888', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '150px' }}>
                                                                https://app.consumerconnect.co...
                                                            </div>
                                                            <div
                                                                onClick={handleLinkClick}
                                                                style={{ width: '30px', height: '30px', background: '#5b8dee', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, cursor: 'pointer' }}
                                                            >
                                                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                                                                    <rect x="9" y="9" width="13" height="13" rx="2" />
                                                                    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                                                                </svg>
                                                            </div>
                                                        </div>
                                                    </div>

                                                   
                                                    

                                                </div>
                                                
                                                <img src={referImage} alt='image' style={{height: '100%'}}/>
                                                
                                            </div>

                                        </div>
                                    </div>
                                </div>



                            </div>












                        </React.Fragment>


                    </LoadingOverlay>

                )}

            />
        </TransitionGroup>
    )

}

export default ConnectPoints;